import { Box, Divider, Flex, Heading, Spacer, Text } from '@chakra-ui/react'
import React from 'react'

export default function FinancialSummary({ reportData }) {

    const summaryData = reportData['Financial Summary'].Summary && Object.keys(reportData['Financial Summary'].Summary).map((key) => {
        return {
            key: key,
            value: reportData['Financial Summary'].Summary[key]
        }
    })

    const adviceData = reportData['Financial Summary'].Advice

    return (
        <Box className='investor_chart'>
            <Heading as="h2" className='font-poppins card_heading'>Financial Summary</Heading>
            <Box mt={2}>
                {summaryData?.map((item, index) => {
                    return (
                        <Box key={index}>
                            <Flex alignItems='center' className='summary-item'>
                                <Heading as="h5" className='font-poppins'>{item.key}</Heading>
                                <Spacer />
                                <Text className='font-poppins'>₹{item.value}</Text>
                            </Flex>
                            <Divider />
                        </Box>
                    )
                })}
            </Box>
            <Box mt={4}>
                <Heading mb={2} as="h2" className='font-poppins card_heading'>Advice</Heading>
                {adviceData?.map((item, index) => {
                    return (
                        <Box className='summary-item' key={index}>
                            <Text className='font-poppins'>{item}</Text>
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}
